import {h, Fragment} from "preact"
export default function Checkbox({ value, selected, onChange, className, isEngravingFacet }) {
    const labelText = isEngravingFacet && value === "1" ? "Yes" : isEngravingFacet && value !== "1" ? "No" : value;
    
    return (
        <label className={`ns-checkbox ns-d-block ns-color-black ns-mr-1 ${className}`}>
            <input 
                type="checkbox" 
                checked={selected} 
                onChange={onChange}
                aria-describedby={`checkbox-${value}`}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        onChange(e);
                    }
                }}
            />
            <span className="ns-checkmark" aria-hidden="true" onClick={(e) => e.stopPropagation()}/>
            <span id={`checkbox-${value}`} className="ns-checkbox-label">
                {labelText}
            </span>
        </label>
    )
}

// version commented on October 2nd to adapt code for ADA compliance

// export default function Checkbox({ value, selected, onChange, className, isEngravingFacet }) {
//     return (
//         <label className={`ns-checkbox ns-d-block ns-color-black ns-mr-1 ${className}`} tabIndex="0">
//             {isEngravingFacet && value === "1" ? "Yes" : isEngravingFacet && value !== "1" ? "No" : value}
//             <input type="checkbox" checked={selected} onChange={onChange} />
//             <span className="ns-checkmark" onClick={(e) => e.stopPropagation()}/>
//         </label>
//     )
// }